import { authFetch } from "@/lib/api-client";
import type { LegacyHubMigrationStatusResponse, LegacyHubMigrationSummary } from "@nexus/contracts";

// Platform-admin routes for "Migrate to hub" (AD-3547). The active tenant is the one migrated.
const BASE = "/persona-opportunity-sets/legacy-migration";

export async function fetchLegacyHubMigrationPreview(): Promise<LegacyHubMigrationSummary> {
  const { data } = await authFetch<LegacyHubMigrationSummary>(`${BASE}/preview`);
  return data;
}

export async function fetchLegacyHubMigrationStatus(): Promise<LegacyHubMigrationStatusResponse> {
  const { data } = await authFetch<LegacyHubMigrationStatusResponse>(`${BASE}/status`);
  return data;
}

/** Queues the run, or returns the run already going for this tenant. */
export async function startLegacyHubMigration(): Promise<{ correlationId: string | undefined }> {
  const { correlationId } = await authFetch<void>(BASE, {
    method: "POST",
    body: JSON.stringify({ idempotencyKey: crypto.randomUUID() }),
  });
  return { correlationId };
}
